<template>
    <comp :is="params.component" v-bind="childProps" @click="params.click($event, params)" />
</template>
<script>
export default {
    name: 'mead-ag-grid-component',
    computed: {
        childProps: function () {
            return Object.assign({}, this.params, this.params.data);
        }
    }
}
</script>